class TimeLine extends HTMLElement {
  constructor() {
    super();
    this.sliderWrapper = this.querySelector('.time-line__slider-wrapper');
    this.slides = this.querySelectorAll('.time-line__slide');
    this.navItems = this.querySelectorAll('.time-line__navigation-item');
    this.progressLine = this.querySelector('.time-line__progress-line');

    this.btnPrev = this.querySelector('.time-line__btn-prev');
    this.btnNext = this.querySelector('.time-line__btn-next');

    this.currentIndex = 0;
    this.currentSize = this.slides.length;
    this.startPosition = this.sliderWrapper.scrollLeft;
    this.scrollPath = this.sliderWrapper.scrollWidth / this.navItems.length

    this.navigateSlider();
    this.buttonsSlider();
    this.highlightOnScroll();
  }

  navigateSlider() {
    this.navItems.forEach((item, index) => {
      item.addEventListener('click', () => {
        this.currentIndex = index;
        this.moveSlider();
        if (window.outerWidth >= 1000) {
          this.highlightSlider(this.currentIndex);
          this.visibilitySliderButtons(this.currentIndex, this.currentSize);
        }
      })
    })
  }

  highlightOnScroll() {
    this.sliderWrapper.addEventListener('scroll', () => {
      let index;
      
      if (window.outerWidth < 1000) {
        index = Math.round(this.sliderWrapper.scrollLeft / (this.sliderWrapper.scrollWidth / this.navItems.length));
      }else{
        index = Math.ceil(this.sliderWrapper.scrollLeft / (this.sliderWrapper.scrollWidth / this.navItems.length));
      }

      this.currentIndex = index;
      this.highlightSlider(this.currentIndex);
    })
  }

  buttonsSlider() {
    this.btnPrev.addEventListener('click', () => {
      this.currentIndex--;
      this.moveSlider();
      this.highlightSlider(this.currentIndex);
      this.visibilitySliderButtons(this.currentIndex, this.currentSize);
    });

    this.btnNext.addEventListener('click', () => {
      this.currentIndex++;
      this.moveSlider();
      this.highlightSlider(this.currentIndex);
      this.visibilitySliderButtons(this.currentIndex, this.currentSize);
    });
  }

  highlightSlider(index) {
    this.progressLine.style.transform = `translateX(${index}00%)`;
    this.slides.forEach(s => s.setAttribute('data-active', 'false'));
    this.slides[index].setAttribute('data-active', 'true');
  }

  visibilitySliderButtons(index, size) {
    index === 0
      ? (this.btnPrev.setAttribute('data-active', 'false'))
      : (this.btnPrev.setAttribute('data-active', 'true'));

    index === size - 1
      ? (this.btnNext.setAttribute('data-active', 'false'))
      : (this.btnNext.setAttribute('data-active', 'true'));
  }

  moveSlider() {
    this.sliderWrapper.scrollLeft = this.startPosition + this.scrollPath * (this.currentIndex);
  }

}
customElements.define("time-line", TimeLine);